import React from 'react';
import { Box, Skeleton } from '@mui/material';
import {
  WebsiteText,
  // DifferenceChip
} from '../KpiCard.style';
import { KPITypesEnum } from 'src/components-bl/Analytics/types';
import { formatKpiWithSign } from 'src/components-bl/Analytics/utils/utils';
// import { Tooltip } from 'src/components-dummy';

interface Props {
  loading: boolean;
  websiteValue: number;
  diff: number;
  kpiType: string;
}

export function renderComparisonFooter({
  loading,
  websiteValue,
  // diff
  kpiType,
}: Props): JSX.Element | null {
  const upliftTypes = ['aov', 'arpu', 'cvr'];
  const splitComparisonTypes = ['syteRevenue', 'cvr', 'arpu', 'aov'];
  if (!upliftTypes.includes(kpiType) && !splitComparisonTypes.includes(kpiType)) {
    return null;
  }

  return (
    <Box display='flex' alignItems='center'>
      {loading ? (
        <Skeleton variant='text' width={120} height={16} />
      ) : splitComparisonTypes.includes(kpiType) ? (
        <WebsiteText>
          {kpiType === KPITypesEnum.Revenue
            ? `out of ${formatKpiWithSign(kpiType as KPITypesEnum, websiteValue)} total website revenue`
            : `vs. ${formatKpiWithSign(kpiType as KPITypesEnum, websiteValue)} on website`}
        </WebsiteText>
      ) : null}
      {/* {upliftTypes.includes(kpiType) && !loading && typeof diff === 'number' && (
        <Tooltip value='uplift'>
          <DifferenceChip diff={diff} label={`${diff.toFixed(2)}%`} />
        </Tooltip>
      )} */}

      {upliftTypes.includes(kpiType) && loading && (
        <Skeleton variant='rectangular' width={50} height={28} sx={{ ml: 1 }} />
      )}
    </Box>
  );
}
